<template>
  <LoginFormContainer>
    <template #title>
      Check your inbox at {{ authenticationStore.email }}
    </template>
    <template #description>
      If your email is registered, you will receive a login link to access into
      your account.
    </template>
    <template #form>
      <router-link class="back-btn px-3 py-2" :to="RouterPath.Login">
        <AppkitIcon icon="icon-arrow-left-fill" size="small" />
        Back to login
      </router-link>
    </template>
  </LoginFormContainer>
</template>

<script setup lang="ts">
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { RouterPath } from "@/models/enum/routerPath";
import { useAuthenticationStore } from "@/stores/authentication";
import LoginFormContainer from "@/views/login-view/LoginFormContainer.vue";

const authenticationStore = useAuthenticationStore();
</script>

<style scoped lang="scss">
.back-btn {
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  color: black;
}
</style>
